import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var Size = /*#__PURE__*/function () {
  function Size() {
    _classCallCheck(this, Size);
  }

  _createClass(Size, null, [{
    key: "format",
    value: function format(valueInByteUnit) {
      var valueInKB = valueInByteUnit / this.binaryBase;
      return valueInKB < this.binaryBase ? "".concat(valueInKB.toFixed(1), "KB") : "".concat((valueInKB / 1024).toFixed(1), "MB");
    }
  }]);

  return Size;
}();

_defineProperty(Size, "binaryBase", 1024);